import baseApi from '../utils/ApiUtils';

export const museumApi = (method, payload = null, params = null) => {
  return baseApi(`/museums/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const museumServicesAction= (method, id, payload = null, params = null) => {
  return baseApi(`/museums/${id}/`, method, params, payload).then(response => {
    return response.data;
  });
};